<template>
  <div class="param-container">
    <!-- 操作按钮 -->
    <div class="compare-buttons ">
      <Button type="success"  icon="ios-analytics-outline" @click="handleCompare" class="compare-button" :loading="compareLoading">
        {{ getTranslation("b060") }}
      </Button>
      &nbsp;
            <Button type="primary" icon="md-download"
        @click="handleCopyParams" class="copy-button" :loading="downloadLoading">
        {{ getTranslation("p084") }}
      </Button>
    </div>
    <Row type="flex" class="device-selection">
      <!-- 源设备选择 -->
      <Col flex="1">
      <Card class="source-device-card" dis-hover>
        <template #title>
          <div class="card-title">
            <Icon type="ios-copy" />
            <span>{{ getTranslation('b057') }} <span v-if="m1SelMac1" class="selected-device-hint">({{ getDeviceName(m1SelMac1) }})</span></span>
          </div>
        </template>
          <div class="tree-area">
            <Tree :key="'source-' + treeVersion" :data="sourceTreeData" :render="renderContent"
                  @on-select-change="selectSource"
                  empty-text=""></Tree>
          </div>
          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b006') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')" size="small"
              class="compare-select" v-model="m1SelLibSourceFrom">
              <Option v-for="item in m1MacLibraryList1" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select>
            </Col>
             <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')" size="small"
              class="compare-select" v-model="m1SelLibSourceTo">
              <Option v-for="item in m1MacLibraryList1" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select>
            </Col>
          </Row>

        </Card>
      </Col>

      <!-- 目标设备选择 -->
      <Col flex="1">
      <Card class="target-device-card" dis-hover>
        <template #title>
          <div class="card-title">
            <Icon type="ios-list" />
            <span>{{ getTranslation('b058') }} <span v-if="m1SelMac2" class="selected-device-hint">({{ getDeviceName(m1SelMac2) }})</span></span>
          </div>
        </template>
        <div class="tree-area">
          <Tree :key="'target-' + treeVersion" :data="targetTreeData" :render="renderContent"
                @on-select-change="selectTarget"
                empty-text=""></Tree>
        </div>
        <div class="target-devices" >
          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b006') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')" size="small"
              class="compare-select" v-model="m1SelLibTargetFrom">
              <Option v-for="item in m1MacLibraryList2" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select>
            </Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')" size="small"
              class="compare-select" v-model="m1SelLibTargetTo">
              <Option v-for="item in m1MacLibraryList2" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select>
            </Col>
          </Row>
        </div>
      </Card>
      </Col>
    </Row>
    <div v-if="resCompare && resCompare.length > 0" class="compare-result-container">
      <div v-for="(group, groupIndex) in resCompare" :key="groupIndex" class="compare-group">
        <div class="group-header" @click="toggleGroup(groupIndex)">
          <Icon :type="collapsedGroups[groupIndex] ? 'ios-arrow-forward' : 'ios-arrow-down'" class="group-toggle-icon" />
          <span class="group-tag">{{ getTranslation('b006') }}</span>
          <span class="group-program">{{ group.sourceCode }}({{ group.sourceProgram }}) ↔ {{ group.targetCode }}({{ group.targetProgram }})</span>
          <span class="group-diff-count">{{ getDiffCount(group) }}</span>
        </div>
        <div class="compare-table" v-show="!collapsedGroups[groupIndex]">
          <div class="table-header">
            <div class="header-cell">{{ getTranslation("b065") }}</div>
            <div class="header-cell">{{ group.sourceCode }}({{ group.sourceProgram }})</div>
            <div class="header-cell">{{ group.targetCode }}({{ group.targetProgram }})</div>
          </div>
          <div v-for="(item, index) in group.items" :key="index" :class="['table-row', { 'abnormal-row': !item.Same }]">
            <div class="table-cell">{{ item.Alias }}</div>
            <div class="table-cell">{{ item.Original }}</div>
            <div class="table-cell">{{ item.Present }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { API_URL } from '@/constants/const.js'
import { kindMapLibrary, postJsError } from '@/util/util';
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
  name: 'ParamCompare',
  components: {

  },
  props: {

  },
  data() {
    return {
      originData: [],
      m1SelMac1: null,
      m1SelLibSourceFrom: 0,
      m1SelLibSourceTo: 0,
      m1SelLibTargetFrom: 0,
      m1SelLibTargetTo: 0,
      m1SelMac2: null,
      resCompare: [],
      collapsedGroups: {},
      compareLoading: false,
      downloadLoading: false,
      treeVersion: 1,
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    macList() {
      const list = [];
      if (this.originData) {
        this.originData.forEach(line => {
          if (line.machines && line.machines.length > 0) {
            line.machines.forEach(m => list.push(m));
          }
        });
      }
      return list;
    },
    sourceTreeData() {
      return this.buildTreeData(this.m1SelMac1);
    },
    targetTreeData() {
      return this.buildTreeData(this.m1SelMac2);
    },
    m1MacLibraryList1() {
      let rs = [];
      let kind = -1;
      this.macList && this.macList.forEach((item) => {
        if (item.id == this.m1SelMac1) {
          kind = item.kind
        }
      })
      if (kind > -1) {
        let size = kindMapLibrary(kind);
        for (var i = 0; i < size; i++) {
          rs.push({ "id": i, "ProgramId": i })
        }
      }
      return rs;
    },
    m1MacLibraryList2() {
      let rs = [];
      let kind = -1;
      this.macList && this.macList.forEach((item) => {
        if (item.id == this.m1SelMac2) {
          kind = item.kind
        }
      })
      if (kind > -1) {
        let size = kindMapLibrary(kind);
        for (var i = 0; i < size; i++) {
          rs.push({ "id": i, "ProgramId": i })
        }
      }
      return rs;
    },


  },
  watch: {

  },
  created() {
    this.init();
  },
  mounted() {


  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      let url = API_URL["productlineGetWithMachine"];
      axios.get(url, { timeout: 300000 })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.originData = res.data.data || [];
            // 默认选中第一台设备
            const macList = [];
            if (this.originData) {
              this.originData.forEach(line => {
                if (line.machines && line.machines.length > 0) {
                  line.machines.forEach(m => macList.push(m));
                }
              });
            }
            if (macList.length > 0) {
              if (!this.m1SelMac1) {
                this.m1SelMac1 = macList[0].id;
              }
              if (!this.m1SelMac2) {
                this.m1SelMac2 = macList[0].id;
              }
            }
            this.treeVersion += 1;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('m041'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    buildTreeData(selectedId) {
      if (!this.originData) return [];
      return this.originData
        .filter(line => line.machines && line.machines.length > 0)
        .map(line => ({
          id: line.id,
          name: line.name,
          expand: selectedId != null && line.machines.some(m => m.id === selectedId),
          children: line.machines.map(m => ({
            id: m.id,
            name: m.code,
            isMachine: true,
            kind: m.kind,
            selected: m.id === selectedId,
          }))
        }));
    },
    selectSource(_selected, data) {
      if (!data || !data.isMachine) return;
      if (this.m1SelMac1 === data.id) return;
      this.m1SelMac1 = data.id;
      this.treeVersion += 1;
    },
    selectTarget(_selected, data) {
      if (!data || !data.isMachine) return;
      if (this.m1SelMac2 === data.id) return;
      this.m1SelMac2 = data.id;
      this.treeVersion += 1;
    },
    toggleNode(node, data, e) {
      if (e) e.stopPropagation();
      if (data && Array.isArray(data.children) && data.children.length) {
        const next = !(data.expand === true);
        this.$set(data, 'expand', next);
        if (node && typeof node.expand !== 'undefined') node.expand = next;
      }
    },
    renderContent(h, { node, data }) {
      let iconVNode;
      var title = data.name;
      let fontSize = '14px';
      let fontWeight = '500';
      if (data.isMachine) {
        // 机器节点：不需要状态圆点，保留缩进空间
        iconVNode = h('span', {
          style: { marginRight: '8px', width: '10px', display: 'inline-block' }
        });
      } else {
        fontSize = '15px';
        fontWeight = '550';
        // 使用箭头图标替代折叠/展开指示
        const isOpen = data.expand === true || node.expand === true;
        iconVNode = h('Icon', {
          props: { type: isOpen ? 'md-arrow-dropdown' : 'md-arrow-dropright', size: 14 },
          style: { marginRight: '4px', cursor: 'pointer', color: '#606266' },
          on: {
            click: (e) => {
              e.stopPropagation();
              this.toggleNode(node, data);
            }
          }
        });
      }

      let clickHandler = {
        click: () => {
          if (!data.isMachine) {
            this.toggleNode(node, data);
          }
        }
      };

      return h('span', {
        on: clickHandler,
        style: { display: 'inline-block', width: '100%' },
        class: { 'tree-item': true, 'is-selected': data.selected === true }
      }, [
        h('span', [
          h('span', { style: { cursor: 'pointer', display: 'inline-flex', alignItems: 'center' } }, [
            iconVNode,
            h('span', { style: { cursor: 'pointer', fontSize: fontSize, fontWeight: fontWeight } }, title)
          ])
        ]),
        h('span', { style: { display: 'inline-block', float: 'right' } }, [

        ])
      ]);
    },
    toggleGroup(groupIndex) {
      this.$set(this.collapsedGroups, groupIndex, !this.collapsedGroups[groupIndex])
    },
    getDiffCount(group) {
      if (!group.items) return ''
      const diffCount = group.items.filter(item => !item.Same).length
      return diffCount > 0 ? diffCount + ' '+this.getTranslation('p085') : this.getTranslation('p086')
    },
    async handleCompare() {
      let url = API_URL["libraryCompare"];
      let mac1 = this.m1SelMac1
      let mac2 = this.m1SelMac2
      let programSourceFrom = this.m1SelLibSourceFrom
      let programSourceTo = this.m1SelLibSourceTo
      let programTargetFrom = this.m1SelLibTargetFrom
      let programTargetTo = this.m1SelLibTargetTo
      let params = {
        mac1: mac1,
        mac2: mac2,
        programSourceFrom: programSourceFrom,
        programSourceTo: programSourceTo,
        programTargetFrom: programTargetFrom,
        programTargetTo: programTargetTo
      }
      if (programSourceTo < programSourceFrom || programTargetTo < programTargetFrom) {
        this.$Message.error(this.getTranslation('p082'));
        return;
      }
      if (programSourceTo - programSourceFrom != programTargetTo - programTargetFrom) {
        this.$Message.error(this.getTranslation('p083'));
        return;
      }
      this.compareLoading = true;
      let res = await axios.get(url, {
        params: params,
        timeout:300000,
      })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        }).finally(() => {
          this.compareLoading = false;
        })
        if (res){
          if (res && res.data && res.data.code == 200) {
            this.resCompare = res.data.data;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('m041'));
          }
        }
        this.compareLoading = false;

    },
    async handleCopyParams() {
      let url = API_URL["libraryDownload"];
      let mac1 = this.m1SelMac1
      let mac2 = this.m1SelMac2
      let programSourceFrom = this.m1SelLibSourceFrom
      let programSourceTo = this.m1SelLibSourceTo
      let programTargetFrom = this.m1SelLibTargetFrom
      let programTargetTo = this.m1SelLibTargetTo
      let params = {
        mac1: mac1,
        mac2: mac2,
        programSourceFrom: programSourceFrom,
        programSourceTo: programSourceTo,
        programTargetFrom: programTargetFrom,
        programTargetTo: programTargetTo
      }
      if (programSourceTo < programSourceFrom || programTargetTo < programTargetFrom) {
        this.$Message.error(this.getTranslation('p082'));
        return;
      }
      if (programSourceTo - programSourceFrom != programTargetTo - programTargetFrom) {
        this.$Message.error(this.getTranslation('p083'));
        return;
      }
      if (mac1 == mac2) {
        this.$Message.error(this.getTranslation('p087'));
        return;
      }
        this.downloadLoading = true;
        this.$Modal.confirm({
            width: 450,
            title: this.getTranslation('b135'),
            okText: this.getTranslation('b181'),
            cancelText: this.getTranslation('b182'),
            content: this.getTranslation('b137') + this.getDeviceName(mac1) + this.getTranslation('p088') + '【'+this.getDeviceName(mac2)+'】？',
              onOk: async() => {
                let res = await axios.get(url, {
                params: params,
                timeout:300000,
              })
              .catch((err) => {
                  postJsError(err)
                  this.downloadLoading = false;
                }).finally(() => {
                  this.downloadLoading = false;
                })
                if (res){
                  if (res && res.data && res.data.code == 200) {
                    this.$Message.success(res.data.msg);
                  } else if (res && res.data && res.data.msg) {
                    this.$Message.error(res.data.msg);
                  } else {
                    this.$Message.error(this.getTranslation('m041'));
                  }
                }
                this.downloadLoading = false;


                },
                onCancel: () => {
                  this.downloadLoading = false;
                }

        });

    },
    getDeviceName(deviceId) {
      const device = this.macList.find(item => item.id === deviceId);
      return device ? device.code : '';
    },
  }
}
</script>

<style scoped>
.param-container {
  padding: 0px;
  margin: 0 auto;

}

.device-selection {
  margin-bottom: 24px;
  width: 100%;
  border:1px solid;
  height:70vh;
}

.source-device-card,
.target-device-card {
  height:75vh;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.source-device-card :deep(.ivu-card-body),
.target-device-card :deep(.ivu-card-body) {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title i {
  font-size: 18px;
  color: #2d8cf0;
}

.selected-device-hint {
  font-size: 13px;
  color: #808695;
  font-weight: normal;
}

.tree-area {
  flex: 1;
  overflow-y: auto;
  overflow-x:hidden;
  margin-bottom: 12px;
  padding: 4px 0;
  border: 1px solid #dcdee2;
  border-radius: 6px;
  min-height: 0;
}

.device-selector {
  padding: 16px 0;
}

.compare-radio-group {
  width: 100%;
}

.radio-item {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.radio-item:hover {
  background-color: #f8f9fa;
}

.compare-radio :deep(.ivu-radio-wrapper) {
  font-size: 14px;
}

.compare-radio :deep(.ivu-radio-checked .ivu-radio-inner) {
  border-color: #2d8cf0;
  background-color: #2d8cf0;
}

.target-devices {
  padding: 0;
  flex-shrink: 0;
}

.compare-fields {
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}

.field-label {
  color: #515a6e;
  font-size: 14px;
  display: flex;
  justify-content: right;
  align-items: center;
  padding-right: 5px;

}

.compare-select {
  width: 100%;
}

.compare-select :deep(.ivu-select-selection) {
  border-radius: 6px;
  border: 1px solid #dcdee2;
  transition: all 0.2s ease;
}

.compare-select :deep(.ivu-select-selection:hover) {
  border-color: #57a3f3;
}

.compare-select :deep(.ivu-select-selection:focus) {
  border-color: #2d8cf0;
  box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
}

.select-all-section {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8eaec;
}


.devices-list {
  margin-bottom: 16px;
}

.device-checkbox-col {
  margin-bottom: 12px;
}

.device-checkbox {
  width: 100%;
}

.device-checkbox :deep(.ivu-checkbox) {
  margin-right: 8px;
}

.disabled-text {
  color: #c5c8ce;
  cursor: not-allowed;
}

.compare-buttons {
  text-align: center;
  margin: 24px 0;
}

.compare-button {
  min-width: 120px;
  height: 30px;
  font-size: 14px;
}

.compare-button :deep(.ivu-icon) {
  margin-right: 8px;
}

.compare-result-container {
  margin-top: 20px;
}

.compare-group {
  margin-bottom: 24px;
  border: 1px solid #e8eaec;
  border-radius: 6px;
  overflow: hidden;
}

.group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #f0f5ff;
  border-bottom: 1px solid #d6e4ff;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.group-header:hover {
  background-color: #e6f0ff;
}

.group-toggle-icon {
  font-size: 14px;
  color: #2d8cf0;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.group-tag {
  font-size: 12px;
  color: #2d8cf0;
  font-weight: 500;
}

.group-program {
  font-size: 13px;
  color: #515a6e;
  font-weight: 600;
  flex: 1;
}

.group-diff-count {
  font-size: 12px;
  color: #808695;
  flex-shrink: 0;
}

.compare-table {
  width: 100%;
}

.table-header {
  display: flex;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e8eaec;

}

.header-cell {
  flex: 1;
  padding: 8px 12px;
  font-size: 12px;
  color: #515a6e;
  text-align: center;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background-color: #f5f7fa;
}

.table-cell {
  flex: 1;
  padding: 8px 12px;
  font-size: 12px;
  color: #606266;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}


.abnormal-row {
  background-color: #fff2f0 !important;
  border-left: 3px solid #ff4d4f;
}

.abnormal-row .table-cell {
  color: #ff4d4f;
}

.abnormal-row:hover {
  background-color: #ffe6e6 !important;
}

/* 树状选择样式 */
.tree-item {
    display: inline-block;
    width: 100%;
    border-radius: 0;
    transition: background 0.15s ease, color 0.15s ease;
    padding: 0 4px;
}

.tree-item.is-selected {
    background: #bae7ff;
    color: #1890ff;
    border-radius: 0;
    padding: 0 4px 0 4px;
    font-weight: 550;
    transition: background 0.2s ease, color 0.2s ease;
}

.tree-area :deep(.ivu-tree-title) {
    width: 100%;
}

.tree-area :deep(.ivu-tree-title:hover) {
    background: #bae7ff;
    transform: scale(1.02);
    transition: background 0.2s ease, transform 0.2s ease;
    color: #333333;
    border-radius: 4px;
    padding: 0 0;
    box-sizing: border-box;
}

.tree-area :deep(.ivu-tree-arrow) {
    display: none;
}
</style>
